import { telecomReportConstants } from "_constants";
import { REHYDRATE } from "redux-persist/lib/constants";
import { produce } from "immer";
let initState = {
  all: [],
  individual: {},
  fields: {},
  loading: false
};
export function reports(state = { ...initState }, action) {
  const { payload, type } = action;

  switch (type) {
    case telecomReportConstants.GET_ALL_REPORTS_TELECOM_SUCCESS:
      return produce(state, (draft) => {
        draft["loading"] = false;
        draft["all"] = payload;
      });
    
    case telecomReportConstants.GET_ONE_REPORT_TELECOM_REQUEST:
      return produce(state, (draft) => {
        draft["loading"] = true;
        draft["individual"] = {};
      });
    case telecomReportConstants.GET_ONE_REPORT_TELECOM_SUCCESS:
      return produce(state, (draft) => {
        let { reportId, data } = payload;
        if (data && data["payload"]) {
          draft["fields"] = { [reportId]: data["payload"] };
        }
        draft["loading"] = false;
      });
    case telecomReportConstants.POST_RUN_REPORT_TELECOM_REQUEST:
      return produce(state, (draft) => {
        draft["loading"] = true;
      })
    case telecomReportConstants.POST_RUN_REPORT_TELECOM_SUCCESS:
      return produce(state, (draft) => {
        let { reportId, data, fields } = payload;

        draft["individual"] = { [reportId]: { data, fields } };
        draft["loading"] = false;
      });
    case telecomReportConstants.POST_RUN_REPORT_TELECOM_ERROR:
      return produce(state, (draft) => {
        draft["loading"] = false;
      });
    case REHYDRATE: {
      if (payload && payload.telecom && payload.telecom.reports) {
        return { ...payload.telecom.reports };
      } else {
        return { ...initState };
      }
    }
    case telecomReportConstants.TELECOM_REPORTS_CLEAR:
      return {
        ...initState,
      };
    default:
      return state;
  }
}
